








import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

@Component
export default class extends Mixins() {
  @Prop() stadiumId!: number;

  status = 0;

  async mounted() {
    const res = await this.$store.dispatch('stadium/allowUpgradeStatus', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.status = Number(res.Data);
    }
  }

  allowUpgrade(e: any) {
    // console.log(e)
    this.$confirm({
      title: '确认信息',
      content: '你确定要操作吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/allowUpgrade', {
          stadium_id: this.stadiumId,
          status: e.target.value,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }
}
